import React from "react";
import { Card, Col, Input, Row } from "antd";

import { SetsField } from ".";

const SetsAssignComponent = (props) => {
    const { isSet = false, selected, handleChange, dropdownOpen } = props;

    return (
        // <Card bodyStyle={{ padding: "8px" }}>
        // <Row gutter={[24, 0]} align="middle">
        // {isSet && (
        <SetsField
            value={selected}
            onChange={handleChange}
            dropdownOpen={dropdownOpen}
        />
        // )}
        // </Row>
        // </Card>
    );
};

export default SetsAssignComponent;
